import { render, staticRenderFns } from "./moveTaskPrompt.vue?vue&type=template&id=171664c4&scoped=true&"
import script from "./moveTaskPrompt.vue?vue&type=script&lang=js&"
export * from "./moveTaskPrompt.vue?vue&type=script&lang=js&"
import style0 from "./moveTaskPrompt.vue?vue&type=style&index=0&id=171664c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171664c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('171664c4')) {
      api.createRecord('171664c4', component.options)
    } else {
      api.reload('171664c4', component.options)
    }
    module.hot.accept("./moveTaskPrompt.vue?vue&type=template&id=171664c4&scoped=true&", function () {
      api.rerender('171664c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/workspace/moveTaskPrompt.vue"
export default component.exports